import Vue from 'vue'
import Vuex from 'vuex'

import storeApp from './store-app'
import storeShare from './store-share'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    storeApp,
    storeShare
  }
})
